/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable indent */
/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { isEqual } from "lodash";
// eslint-disable-next-line import/no-extraneous-dependencies
// import { Slider } from "@mui/material";
import Spinner from "../../../components/common/Icons/Spinner/Spinner";
import LabelsPicker from "../../../components/common/Inputs/LabelsPicker/LabelsPicker/LabelsPicker";
import {
  formatConnectorType,
  formatDriveInterfaces,
  formatMotorEncoder,
  formatNbPhases,
  formatShaftEnd
} from "../../../components/Retrofit/Devices/Filters/utils";
import EditableConfigurationName from "../../../components/common/EndPage/EditableConfigurationName/EditableConfigurationName";
import Navigator from "../../../layouts/Navigator/Navigator";
import {
  addNewAxis,
  selectApplicationSettingsChanged,
  selectConfigAxes,
  selectRetrofitConfiguration,
  selectDriveSynchronizedFilters,
  selectFiltersInit,
  selectHighlightApplicationSettingsErrors,
  selectPossibleFiltersValues,
  selectRetrofitSteps,
  setApplicationSettings,
  setApplicationSettingsChanged,
  setCurrentStep,
  setDriveSynchronizedFilters,
  setHighlightApplicationSettingsErrors,
  showSnackbar
} from "../../../store/slices/retrofit";
import { logEvent, syncFiltersDependencies } from "../../../utils/common/api/api";
import { tData } from "../../../utils/common/translation/dataUtils";
import t from "../../../utils/common/translation/translator";
import SharedSurvey from "../../../components/Retrofit/Survey/SharedSurvey";
import { selectConfigurationType, selectEventsData, updateConfiguration } from "../../../store/slices/common";

const ApplicationSettings = () => {
  const voltagesData = {
    "1 Phase": [100, 110, 120, 200, 220, 230, 240],
    "3 Phases": [200, 208, 220, 240, 380, 400, 480]
  };

  const dispatch = useDispatch();
  const steps = useSelector(selectRetrofitSteps);

  const configurationType = useSelector(selectConfigurationType);

  const configuration = useSelector(selectRetrofitConfiguration);

  const [data, setData] = useState(configuration?.configData?.applicationSettings);
  const axes = useSelector(selectConfigAxes);

  const highlightErrors = useSelector(selectHighlightApplicationSettingsErrors);

  const applicationSettingsChanged = useSelector(selectApplicationSettingsChanged);

  useEffect(() => {
    dispatch(setHighlightApplicationSettingsErrors(false));
  }, []);

  const [firstVisit, setFirstVisit] = useState(true);
  useEffect(() => {
    if (configuration?.configData?.applicationSettings) {
      setFirstVisit(false);
    }
  }, []);

  const [initialFilters, setInitialFilters] = useState(null);

  useEffect(() => {
    if (configuration?.configData?.applicationSettings) {
      setInitialFilters(configuration?.configData?.applicationSettings);
    }
    dispatch(setApplicationSettingsChanged(false));
  }, []);

  const continueAction = () => {
    // if filters are not set, show a popup
    if (!data?.nbPhases?.length || !data?.driveVoltages?.length || !data?.driveInterface?.length) {
      dispatch(setHighlightApplicationSettingsErrors(true));
      return;
    }
    // if number of axes === 0, add an axis
    if (axes.length === 0) {
      dispatch(addNewAxis());
    }
    // applicationSettingsChanged is !firstVisit && !isEqual(initialFilters, data)
    if (applicationSettingsChanged) {
      dispatch(showSnackbar({ id: "APPLICATION_SETTINGS_CHANGED" }));
      dispatch(setApplicationSettingsChanged(false));
    }

    dispatch(setCurrentStep(steps.SPECIFY_SELECT));
    dispatch(updateConfiguration());
  };

  const synchronizedDriveFilters = useSelector(selectDriveSynchronizedFilters);
  // eslint-disable-next-line no-unused-vars
  const [syncronizedFilters, setSyncronizedFilters] = useState(JSON.parse(JSON.stringify(synchronizedDriveFilters)));

  const possibleDriveFiltersValues = useSelector(selectPossibleFiltersValues)?.drive;

  // const getDisabledNbPhases = (nbPhases) => {
  //   const disabledLabels = [];
  //   // console.log("getDisabledNbPhases", nbPhases);
  //   if (
  //     !nbPhases.some((r) =>
  //       ["SINGLE_PHASE", "SINGLE_OR_THREE_PHASES"].includes(r)
  //     )
  //   ) {
  //     disabledLabels.push("1 Phase");
  //   }

  //   if (!nbPhases.some((r) => ["2_PHASES"].includes(r))) {
  //     disabledLabels.push("2 Phases");
  //   }

  //   if (
  //     !nbPhases.some((r) =>
  //       ["3_PHASES", "THREE_PHASE", "SINGLE_OR_THREE_PHASES"].includes(r)
  //     )
  //   ) {
  //     disabledLabels.push("3 Phases");
  //   }
  //   return disabledLabels;
  // };

  const filtersInit = useSelector(selectFiltersInit);

  //   useEffect(() => {
  //     setData(configuration?.configData?.ApplicationSettings);
  //   }, []);

  const [firstOccurence, setFirstOccurence] = useState(true);
  useEffect(() => {
    if (!firstOccurence) {
      dispatch(setApplicationSettingsChanged(!isEqual(initialFilters, data) && !firstVisit));
      dispatch(setApplicationSettings(data));
      dispatch(updateConfiguration());
    } else {
      setFirstOccurence(false);
    }
  }, [data]);

  const eventsData = useSelector(selectEventsData);
  const {
    refetch: execSyncFilters,
    isFetching: isFetchingSyncFilters,
    isLoading: isLoadingSyncFilters
  } = useQuery(
    "SYNC_APPLICATION_SETTINGS_FILTERS",
    async () => {
      try {
        const motorFilters = filtersInit?.motorFilter;
        const driveFilters = filtersInit?.driveFilter;
        const gearboxFilters = filtersInit?.gearboxFilter;

        const motorEncoderFormatted = formatMotorEncoder(motorFilters?.motorEncoder);
        const shaftEndFormatted = formatShaftEnd(motorFilters?.shaftEnd);
        const connectorTypeFormatted = formatConnectorType(motorFilters?.connectorType);
        const nbPhasesFormatted = formatNbPhases(data?.nbPhases);

        const payload = {
          device: "ALL",
          criteria: {
            locale: window.msizerConfiguration?.locale || "en-WW",
            step: "drive",
            applicationData: {
              withGearbox: motorFilters?.withGearbox,
              nominalTorqueOfMotor: motorFilters?.nominalTorque,
              nominalSpeedOfMotor: motorFilters?.nominalSpeed
            },
            drive: {
              type: driveFilters?.driveType || [],
              communicationInterfaces: data?.driveInterface || [],
              outputCurrents: driveFilters?.outputCurrent || [],
              nominalPower: driveFilters?.nominalPower || [],
              switchingFreq: driveFilters?.switchingFreq || [],
              format: driveFilters?.format || [],
              nbPhases: nbPhasesFormatted,
              driveVoltages: data?.driveVoltages || []
            },
            motor: {
              type: motorFilters?.motorType || [],
              feedbackType: motorEncoderFormatted,
              connectorType: connectorTypeFormatted,
              ipProtection: motorFilters?.ipDegreeOfProtection || [],
              holdingBrake: motorFilters?.holdingBrake || [],
              shaftEnd: shaftEndFormatted,
              length: motorFilters?.length,
              flangeSize: motorFilters?.flangeSize
            },
            gearbox: {
              productOrComponentType: motorFilters?.withGearbox ? gearboxFilters?.productOrComponentType || [] : [],
              reductionRatio: motorFilters?.withGearbox ? gearboxFilters?.ratio || [] : [],
              torsionalBacklash: data?.withGearbox ? gearboxFilters?.torsionalBacklash : undefined,
              externalDiameter: motorFilters?.withGearbox ? gearboxFilters?.externalDiameter || [] : []
            }
          }
        };

        const newFilters = await syncFiltersDependencies(configurationType, payload);
        const synchronizedFiltersCopy = newFilters?.drive;

        // make a request for each nbPhases (keys of the object voltagesData)
        const nbPhasesPayloadsResults = await Promise.all(
          Object.keys(voltagesData)?.map(async (phase) => {
            const payloadNbPhases = {
              ...payload,
              nbPhasesStep: phase,
              criteria: {
                ...payload.criteria,
                drive: {
                  ...payload.criteria.drive,
                  nbPhases: formatNbPhases([phase]),
                  driveVoltages: []
                }
              }
            };
            const result = await syncFiltersDependencies(configurationType, payloadNbPhases);
            return { [phase]: result };
          })
        ).then((results) => {
          const res = {};
          results.forEach((result) => {
            const key = Object.keys(result)[0];
            res[key] = result[key]?.drive?.outputVoltages;
          });
          return res;
        });
        // console.log("nbPhasesPayloadsResultss", nbPhasesPayloadsResults);

        setSyncronizedFilters({
          ...synchronizedFiltersCopy,
          voltagesPerPhase: nbPhasesPayloadsResults
        });

        dispatch(
          setDriveSynchronizedFilters({
            ...synchronizedFiltersCopy,
            voltagesPerPhase: nbPhasesPayloadsResults
          })
        );

        // get the old data to keep the selected values
        const oldData = configuration?.configData?.applicationSettings;

        // communication interfaces
        if (synchronizedFiltersCopy.communicationInterfaces?.length === 1) {
          // check the value of driveInterface is different from the current value and different from the old value
          if (
            synchronizedFiltersCopy.communicationInterfaces[0] !== data.driveInterface?.[0] &&
            synchronizedFiltersCopy.communicationInterfaces[0] !== oldData.driveInterface?.[0]
          ) {
            setData({
              ...data,
              driveInterface: synchronizedFiltersCopy.communicationInterfaces
            });
          }
        }
        // drive voltages
        if (synchronizedFiltersCopy.outputVoltages?.length === 1) {
          // check the value of driveVoltages is different from the current value and different from the old value
          if (
            synchronizedFiltersCopy.outputVoltages[0] !== data.driveVoltages?.[0] &&
            synchronizedFiltersCopy.outputVoltages[0] !== oldData.driveVoltages?.[0]
          ) {
            console.log("handleSetVoltage", synchronizedFiltersCopy.outputVoltages);
            setData({
              ...data,
              driveVoltages: synchronizedFiltersCopy.outputVoltages
            });
          }
        }
        // nb phases
        // todo later : new export DAL
        return newFilters;
      } catch (error) {
        // dispatch(showMinimalPopup(`Filters dependencies error`));
        dispatch(showSnackbar({ id: "ERROR_FILTERS" }));
        logEvent(eventsData.locale, eventsData.types.errorFilters, eventsData.tags.none, configuration?.configId);

        console.error("ERR", error.response?.status);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  useEffect(() => {
    execSyncFilters();
  }, [data, filtersInit]);

  // eslint-disable-next-line no-unused-vars
  const onSelectManually = (filterName) => {
    // console.log("onSelectManually", filterName);
    // if all application settings are selected (we do not check the data[filterName]), we can go to the next step
    // ["nbPhases", "driveInterface", "driveVoltages"] except filterName
    // check if every data.[element]?.length > 0
    // const allSelected = ["nbPhases", "driveInterface", "driveVoltages"].every(
    //   (element) => {
    //     if (element === filterName) return true;
    //     return data[element]?.length > 0;
    //   }
    // );
    // setTimeout(() => {
    //   if (allSelected) {
    //     console.log("all selected manually");
    //     if (axes.length === 0) {
    //       dispatch(addNewAxis());
    //     }
    //     dispatch(setCurrentStep(steps.SPECIFY_SELECT));
    //   }
    // }, 1000);
  };

  // const voltageValues = [100, 110, 120, 200, 208, 220, 240, 380, 400, 480];

  // // index of the element / length of voltageValues array * 100
  // const marks = voltageValues.map((voltage, index) => ({
  //   value: (index / (voltageValues.length - 1)) * 100,
  //   label: `${voltage} V`
  // }));

  // const valuetext = (value) => `${value} V`;

  // // const valueLabelFormat = (value) =>
  // //   marks.findIndex((mark) => mark.value === value) + 1;

  // const valueLabelFormat = (value) => {
  //   const index = Math.round((value / 100) * (voltageValues.length - 1));
  //   return `${voltageValues[index]} V`;
  // };

  /* possibleDriveFiltersValues?.driveVoltages is [
    "380...480 V",
    "100...120 V",
    "200...240 V",
    "208...480 V",
    "220 V",
    "110 V"
  ]
  create a new array with the min and max values, distinct values and order them
  */

  const sortDriveVoltages = (driveVoltages) => {
    const ranges = [];
    const singleValues = [];

    // For each value check if it contains "..." if yes it get pushed to the "ranges" array, if not it get pushed to the "singleValues" array. Every NaN elements are removed.
    driveVoltages?.forEach((voltage) => {
      if (voltage.includes("...")) {
        const rangeValues = voltage
          .split("...")
          .map((part) => parseInt(part.trim(), 10))
          .filter((num) => !Number.isNaN(num));
        ranges.push(...rangeValues);
      } else {
        const num = parseInt(voltage.trim(), 10);
        if (!Number.isNaN(num)) {
          singleValues.push(num);
        }
      }
    });

    ranges.sort((a, b) => a - b);

    // Return an object with the min and max of the ranges array and the array of single values.
    return {
      min: ranges[0],
      max: ranges[ranges.length - 1],
      singleValues
    };
  };

  // const splitDriveVoltages = (driveVoltages) =>
  //   [
  //     ...new Set(
  //       driveVoltages
  //         ?.map((val) => {
  //           const values = val.split("...").map((v) => parseInt(v, 10));
  //           return values;
  //         })
  //         .flat()
  //         .filter((val) => !Number.isNaN(val))
  //     )
  //   ].sort((a, b) => a - b);

  // const possibleDriveVoltages = splitDriveVoltages(
  //   possibleDriveFiltersValues?.driveVoltages
  // );

  const [loadingSetVoltage, setLoadingSetVoltage] = useState(false);
  // selectedLablesInit for each phase is data?.nbPhases?.includes(phase) ? data?.driveVoltagesSplitted : []
  const [selectedLabelsInit, setSelectedLabelsInit] = useState(
    Object.keys(voltagesData)?.reduce((acc, phase) => {
      if (data?.nbPhases?.includes(phase)) {
        acc[phase] = data?.driveVoltagesSplitted;
      }
      return acc;
    }, {})
  );

  const handleSetVoltage = (voltageValue, phase) => {
    /*
      example : val = [220]
      driveVoltage should be ["200...240 V", "220 V", "208...480 V"]
      (220 is between 200 and 240..etc)

      set the nbPhases to the given value if the voltage is not empty
    */

    const driveVoltage =
      // syncronizedFilters?.outputVoltages?.filter(
      possibleDriveFiltersValues?.driveVoltages?.filter((voltage) => {
        if (voltage.includes("...")) {
          const values = voltage.split("...").map((v) => parseInt(v, 10));
          return values[0] <= voltageValue[0] && voltageValue[0] <= values[1];
        }
        return parseInt(voltage, 10) === voltageValue[0];
      });

    // set the data only if it's different from the previous value
    const newData = {
      ...data,
      nbPhases: voltageValue?.length ? [phase] : [],
      driveVoltagesSplitted: voltageValue,
      driveVoltages: driveVoltage
    };

    if (JSON.stringify(newData) !== JSON.stringify(data)) {
      // console.log("handleSetVoltage", voltageValue, "=>", driveVoltage, phase);
      setData({
        ...data,
        nbPhases: voltageValue?.length ? [phase] : [],
        driveVoltagesSplitted: voltageValue,
        driveVoltages: driveVoltage
      });
    }

    const newSelectedLabelsInit = {
      [phase]: voltageValue
    };
    // console.log("newSelectedLabelsInit", newSelectedLabelsInit);
    setSelectedLabelsInit(newSelectedLabelsInit);
    setTimeout(() => {
      setLoadingSetVoltage(false);
    }, 100);
  };

  const [currentPhaseBeingSelected, setCurrentPhaseBeingSelected] = useState(null);

  // // check the compatibility between the selected voltage, and the synchronized filters
  // useEffect(() => {
  //   // if data.driveVoltages contains a value that is not in synchronizedFilters.voltagesPerPhase[currentPhaseBeingSelected]
  //   // then remove it from data.driveVoltages
  //   if (currentPhaseBeingSelected) {
  //     const synchronizedVoltages =
  //       synchronizedDriveFilters?.voltagesPerPhase?.[currentPhaseBeingSelected];
  //     const driveVoltages = data?.driveVoltages;
  //     const newDriveVoltages = driveVoltages?.filter((voltage) =>
  //       synchronizedVoltages?.includes(voltage)
  //     );
  //     if (JSON.stringify(newDriveVoltages) !== JSON.stringify(driveVoltages)) {
  //       console.log("handleSetVoltage", newDriveVoltages);
  //       setData({ ...data, driveVoltages: newDriveVoltages });
  //     }
  //   }
  //   console.log("debug :", synchronizedDriveFilters?.voltagesPerPhase);
  // }, [synchronizedDriveFilters]);

  // voltage filter as jsx element
  const voltageFilter = (
    <>
      <div className="m-1 md:m-0 space-x-1 ">
        <span className="text-sm font-semibold text-gray-600">{t("msizer.ui.app_settings.select_voltage")}</span>
        <span className="text-red-600 text-sm">*</span>
      </div>
      {Object.entries(voltagesData).map(([phase, values]) => (
        <div onClick={() => setCurrentPhaseBeingSelected(phase)}>
          {/* <span className="text-xs">{tData("drive", "nb_phases", phase)}</span> */}
          <LabelsPicker
            idLabel={`voltage-${Array.from(phase)[0]}`}
            label={tData("drive", "nb_phases", phase)}
            singleChoice
            large
            cols={3}
            options={values?.map((voltage) => ({
              label: `${voltage} V`,
              key: voltage
            }))}
            onChange={(voltage) => {
              if (currentPhaseBeingSelected === phase) {
                setLoadingSetVoltage(true);
                handleSetVoltage(voltage, phase);
              }
            }}
            selectedLabelsInit={
              selectedLabelsInit[phase] || []
              // data?.nbPhases?.includes(phase) ? data?.driveVoltagesSplitted : []
            }
            changeWithInit={loadingSetVoltage}
            disabledLabels={values?.filter((val) => {
              // Check if the value is a single value, if not check if it's out of range
              const sortedDriveVoltages = sortDriveVoltages(synchronizedDriveFilters?.voltagesPerPhase?.[phase]);

              if (sortedDriveVoltages.singleValues?.includes(val)) return false;

              if (!sortedDriveVoltages.min && !sortedDriveVoltages.max) {
                return true;
              }

              return val < sortedDriveVoltages.min || val > sortedDriveVoltages.max || !syncronizedFilters;
            })}
            error={highlightErrors && !data?.driveVoltages?.length}
          />
        </div>
      ))}
      {/* <LabelsPicker
        onSelectManually={() => onSelectManually("nbPhases")}
        singleChoice
        required
        large
        label={`OLD: ${t("msizer.ui.app_settings.select_nb_phases")}`}
        cols={3}
        options={[
          ...possibleDriveFiltersValues.nbPhases
            .filter(
              (nbp) =>
                ![
                  null,
                  "3_PHASES",
                  "SINGLE_PHASE",
                  "2_PHASES",
                  "THREE_PHASE",
                  "SINGLE_OR_THREE_PHASES"
                ].includes(nbp)
            )
            .concat(["1 Phase", "3 Phases"])
            .map((val) => ({
              label: tData("drive", "nb_phases", val),
              key: val
            }))
        ]}
        selectedLabelsInit={data?.nbPhases}
        onChange={() => {
          // setData({ ...data, nbPhases: val });
        }}
        changeWithInit
        disabledLabels={getDisabledNbPhases(syncronizedFilters?.nbPhases || [])}
        error={highlightErrors && !data?.nbPhases?.length}
      />
      <LabelsPicker
        label={`OLD ${t("msizer.ui.app_settings.select_voltage")}`}
        required
        large
        cols={3}
        // order options alphabetically
        options={[
          ...possibleDriveFiltersValues?.driveVoltages
            ?.filter((val) => val !== null)
            ?.sort()
            ?.map((val) => ({
              label: `${val}`,
              key: val
            }))
        ]}
        selectedLabelsInit={data?.driveVoltages}
        changeWithInit
        disabledLabels={possibleDriveFiltersValues.driveVoltages?.filter(
          (val) =>
            !syncronizedFilters?.outputVoltages?.includes(val) ||
            !syncronizedFilters
        )}
        error={highlightErrors && !data?.driveVoltages?.length}
      /> */}

      {/* <LabelsPicker
        label={`NEW VERSION : ${t("msizer.ui.app_settings.select_voltage")}`}
        singleChoice
        required
        large
        cols={3}
        // order options alphabetically
        options={[
          ...possibleDriveVoltages?.map((val) => ({
            label: `${val} V`,
            key: val
          }))
        ]}
        onChange={(val) => {
          console.log("changed!, old val", data?.driveVoltages, "new val", val);
          handleSetVoltage(val);
        }}
        // selectedLabelsInit={data?.driveVoltages}
        changeWithInit
        disabledLabels={splitDriveVoltages(
          possibleDriveFiltersValues.driveVoltages?.filter(
            (val) =>
              !syncronizedFilters?.outputVoltages?.includes(val) ||
              !syncronizedFilters
          )
        )}
        error={highlightErrors && !data?.driveVoltages?.length}
      /> */}

      {/* <Slider
        aria-label="Restricted values"
        defaultValue={50}
        disableSwap
        track={false}
        valueLabelFormat={valueLabelFormat}
        getAriaValueText={valuetext}
        step={null}
        valueLabelDisplay="auto"
        marks={marks}
        sx={{
          color: "#626469",
          "& .MuiSlider-thumb": {
            height: 17,
            width: 17,
            backgroundColor: "#fff",
            border: "1px solid currentColor",
            "&:hover": {
              boxShadow: "0 0 0 8px rgba(58, 133, 137, 0.16)"
            }
          },
          "& .MuiSlider-track": {
            height: 5
          },
          "& .MuiSlider-rail": {
            color: "#d8d8d8",
            opacity: 1,
            height: 5
          },
          // cutomize the mark label
          "& .MuiSlider-markLabel": {
            fontSize: 12
          },
          // customize the valueLbael
          "& .MuiSlider-valueLabel": {
            fontSize: 12,
            borderRadius: 4,
            backgroundColor: "#d8d8d8",
            color: "#626469"
          }
        }}
        onChange={(event, newValues) => {
          console.log("newValues", newValues);
          const index = Math.round(
            (newValues / 100) * (voltageValues.length - 1)
          );
          const voltage = voltageValues[index];
          console.log("voltage", voltage);
        }}
      /> */}
    </>
  );

  const communicationInterfaceFilter = (
    <LabelsPicker
      idLabel="communication-interface"
      onSelectManually={() => onSelectManually("driveInterface")}
      singleChoice
      large
      label={t("msizer.ui.app_settings.select_communication")}
      largeLabel
      required
      cols={3}
      options={[
        ...(formatDriveInterfaces(possibleDriveFiltersValues?.driveInterface) || [])?.map((val) => ({
          label: tData("drive", "communication_interfaces", val),
          key: val
        }))
      ]}
      selectedLabelsInit={data?.driveInterface}
      changeWithInit
      onChange={(type) => {
        setData({
          ...data,
          driveInterface: type
        });
      }}
      // changeWithInit
      disabledLabels={formatDriveInterfaces(possibleDriveFiltersValues?.driveInterface)?.filter(
        (val) => !syncronizedFilters?.communicationInterfaces?.includes(val)
      )}
      error={highlightErrors && !data?.driveInterface?.length}
    />
  );

  return (
    <div>
      <div className="md:border-[1px] md:border-gray-100 md:shadow-lg md:p-4 md:rounded-sm md:border-solid">
        <EditableConfigurationName blue />
        <div className="relative">
          <div
            className={`bg-gray-50 backdrop-blur-xs bg-opacity-50 h-full w-full top-0 left-0 absolute flex items-center justify-center z-20 ${
              !(isFetchingSyncFilters || isLoadingSyncFilters) && "hidden"
            }`}
          >
            <Spinner id="loading_spinner" />
          </div>
          <div className="md:grid md:grid-cols-2 divide-y md:divide-y-0 divide-solid space-y-4 md:space-y-0 md:divide-gray-200 md:my-3">
            <div className="md:border-r-2 divide-y md:divide-y-0 space-y-4">
              <div className="md:flex-1 space-y-5 md:px-5">{voltageFilter}</div>
            </div>
            <div className="md:flex-1 space-y-5 md:px-5">{communicationInterfaceFilter}</div>
          </div>
        </div>
      </div>
      <Navigator
        continueButtonDisabled={
          !data?.nbPhases?.length || !data?.driveVoltages?.length || !data?.driveInterface?.length
        }
        continueAction={continueAction}
      />
      <SharedSurvey />
    </div>
  );
};

export default ApplicationSettings;
